export const EXPERT_AVAILABILITY_UPDATED = 'EXPERT_AVAILABILITY_UPDATED';
